import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import React, { useState, useRef } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomTextField from "../CustomComponents/CustomTextField";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import store from "../Store";
import { BranchAction } from "../Store/Branch";
import { NachFilterReducerAction } from "../Store/NachFilterReducer";
import { NachAction } from "../Store/NachStore";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const NachFilter = () => {
  //importing hook
  const dispatch = useDispatch();

  //Selectors from redux store
  const FilteredData = useSelector((state) => state.nachFilter.data);
  const initialLoadData = useSelector(
    (state) => state.nachFilter.initialLoadData
  );
  const finalData = useSelector((state) => state.nachFilter.finalData);
  const filData = useSelector((state) => state.nachFilter.filterData);
  const editLock = useSelector((state) => state.nachFilter.editLock);
  const detailScreenViewFlag = useSelector(
    (state) => state.nachFilter.showMandate
  );
  //Filter conditions State value
  const [branchArray, setBranchArray] = useState([]);
  const [applicationArray, setApplicationArray] = useState([]);
  const [bankAccountArray, setBankAccountArray] = useState([]);
  const [selectedAccountNum, setselectedAccountNum] = useState("");
  const [selectedData, setSelectedData] = useState();

  const [mode, setMode] = useState();
  //All Data
  const [losData, setLosData] = useState("");
  const [mandateRecords, setMandateRecords] = useState([]);
  const userNames = useSelector((state) => state.branch.userName);
  const [editLockDialogOpen, setEditLockDialogOpen] = useState();
  const editLockStatus = useSelector(
    (state) => state.nachFilter.mandateDialogFlag.editLockStatus
  );
  const [DialogOpen, setDialogOpen] = useState(false);
  //Input Validtion
  const branchValid =
    filData.branchValue !== undefined &&
    filData.branchValue !== null &&
    filData.branchValue !== "";
  const applicationNumberValid =
    filData.applicationValue !== undefined &&
    filData.applicationValue !== null &&
    filData.applicationValue !== "";
  const bankAccountNumValid =
    filData.bankAccountNum !== undefined &&
    filData.bankAccountNum !== null &&
    filData.bankAccountNum !== "";
  //Has Error
  const branchHasError = filData.branchTouch && !branchValid;
  const applicationHasError =
    filData.applicationTouch && !applicationNumberValid;
  const bankAccountHasError =
    filData.bankAccountNumTouch && !bankAccountNumValid;
  let compareTwoArrayOfObjects = (obj1, obj2) => {
    return (
      obj1.length === obj2.length &&
      obj1.every((element_1) =>
        obj2.some((element_2) =>
          Object.keys(element_1).every(
            (key) => element_1[key] === element_2[key]
          )
        )
      )
    );
  };
  //shortcut key
  //shortcut key
  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  const cancelRef = useRef(null);
  const okRef = useRef(null);

  const editOkRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);

  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "nachFilter",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = { cancelRef: cancelRef };
    if (event.ctrlKey) {
      if (charCode === "f") {
        searchButtonRef && searchButtonRef.current.click();
      } else if (charCode === "d") {
        clearRef && clearRef.current.click();
      } else if (charCode === "k") {
        okRef.current !== null && okRef.current.click();
        editOkRef.current !== null && editOkRef.current.click();
      } else if (charCode === "q") {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "nachFilter",
          })
        );
      }
    }
  };
  //Methods
  const branchOnChangeHandler = (value) => {
    setMode("BranchMode");
    setSelectedData(value);
    if (detailScreenViewFlag) {
      const result = compareTwoArrayOfObjects([initialLoadData], [finalData]);
      if (!result) {
        setDialogOpen(true);
      } else {
        if (!editLock.editLockFlag) {
          let { editLockFlag, branch, applicationNumber } = editLock;
          if (branch !== "" && applicationNumber !== "") {
            releaseLock(branch, applicationNumber);
          }
        }
        dispatch(NachFilterReducerAction.updateEditLockBranch(value.label));
        if (value !== "") {
          dispatch(BranchAction.updateInitialLoad(false));
          dispatch(BranchAction.updateHeaderBranchDetails(value.label));
        }

        setApplicationArray([]);
        setBankAccountArray([]);
        dispatch(NachFilterReducerAction.updateShowMandate(false));
        // dispatch(NachFilterReducerAction.updateApplicationTouchHandler(false));
        dispatch(NachFilterReducerAction.resetValues());

        dispatch(NachFilterReducerAction.updateApplicationValue(""));
        dispatch(NachFilterReducerAction.updateBankAccountNumValue(""));

        dispatch(NachFilterReducerAction.updateBranchValue(value));
        const branchCodeValue = getSelectedBranchCode(value.label);
        const applicationArray = losData.filter((item) => {
          return item.branchCode === branchCodeValue;
        });
        const app = applicationArray.map((itm) => itm.applicationNum);
        setApplicationArray(app);
      }
    } else {
      if (!editLock.editLockFlag) {
        let { editLockFlag, branch, applicationNumber } = editLock;
        if (branch !== "" && applicationNumber !== "") {
          releaseLock(branch, applicationNumber);
        }
      }
      dispatch(NachFilterReducerAction.updateEditLockBranch(value.label));
      setApplicationArray([]);
      setBankAccountArray([]);
      dispatch(NachFilterReducerAction.updateShowMandate(false));
      // dispatch(NachFilterReducerAction.updateApplicationTouchHandler(false));
      dispatch(NachFilterReducerAction.resetValues());
      if (value !== "") {
        dispatch(BranchAction.updateInitialLoad(false));
        dispatch(BranchAction.updateHeaderBranchDetails(value.label));
      }

      dispatch(NachFilterReducerAction.updateApplicationValue(""));
      dispatch(NachFilterReducerAction.updateBankAccountNumValue(""));

      dispatch(NachFilterReducerAction.updateBranchValue(value));
      const branchCodeValue = getSelectedBranchCode(value.label);
      const applicationArray = losData.filter((item) => {
        return item.branchCode === branchCodeValue;
      });
      const app = applicationArray.map((itm) => itm.applicationNum);
      setApplicationArray(app);
    }
  };
  const editLockOkButonHandler = () => {
    setEditLockDialogOpen(false);
  };
  const applicationNumberOnChangeHandler = (value) => {
    setMode("applicationMode");
    setSelectedData(value);
    if (detailScreenViewFlag) {
      const result = compareTwoArrayOfObjects([initialLoadData], [finalData]);
      if (!result) {
        setDialogOpen(true);
      } else {
        if (!editLock.editLockFlag) {
          let { editLockFlag, branch, applicationNumber } = editLock;
          if (branch !== "" && applicationNumber !== "") {
            releaseLock(branch, applicationNumber);
          }
        }
        dispatch(
          NachFilterReducerAction.updateEditLockApplicationNumber(value)
        );
        dispatch(NachFilterReducerAction.updateApplicationValue(value));
        dispatch(NachFilterReducerAction.updateBankAccountNumValue(""));
        dispatch(NachFilterReducerAction.updateShowMandate(false));
        dispatch(NachFilterReducerAction.resetValues());
        changeAppNumReq(value);
      }
    } else {
      if (!editLock.editLockFlag) {
        let { editLockFlag, branch, applicationNumber } = editLock;
        if (branch !== "" && applicationNumber !== "") {
          releaseLock(branch, applicationNumber);
        }
      }
      dispatch(NachFilterReducerAction.updateEditLockApplicationNumber(value));
      dispatch(NachFilterReducerAction.updateApplicationValue(value));
      dispatch(NachFilterReducerAction.updateBankAccountNumValue(""));
      dispatch(NachFilterReducerAction.updateShowMandate(false));
      dispatch(NachFilterReducerAction.resetValues());
      changeAppNumReq(value);
    }
  };
  const changeAppNumReq = async (value) => {
    setBankAccountArray([]);
    setMandateRecords([]);
    try {
      const branchCodeValue = getSelectedBranchCode(filData.branchValue.label);
      const response = await axios.post("/nach/getDisbRequestedData", {
        branch: filData.branchValue.label,
        branchCode: branchCodeValue,
        applicationNum: value,
      });
      let lockStatus = response.data[0].editLock;
      dispatch(NachFilterReducerAction.updateEditLockFlag(lockStatus));
      dispatch(NachFilterReducerAction.updateEditLockStatus(lockStatus));
      const mandateRecordsData = [...response.data];
      setMandateRecords(mandateRecordsData);
      const bankAccountNums = [];
      mandateRecordsData.forEach((row) => {
        row.nachBankVoList.forEach((bankRow) =>
        bankAccountNums.push(bankRow.bankAccountNum)
        );
      });
      setBankAccountArray(bankAccountNums);
    } catch {}
  };

  const createBankDetailsVo = (row, bankrecord) => {
    row.accountType = bankrecord.accountType;
    row.bankAccHolderName = bankrecord.bankAccHolderName;
    row.bankAccountNum = bankrecord.bankAccountNum;
    row.bankName = bankrecord.bankName;
    row.branchName = bankrecord.branchName;
    row.ifscCode = bankrecord.ifscCode;
    row.micr = bankrecord.micr;
  };

  const changeBankAccountNumValue = (value) => {
    setMode("accountMode");
    setSelectedData(value);
    if (detailScreenViewFlag) {
      const result = compareTwoArrayOfObjects([initialLoadData], [finalData]);
      if (!result) {
        setDialogOpen(true);
      } else {
        dispatch(NachAction.setResetTouchHandler(false));
        if (editLockStatus) {
          setEditLockDialogOpen(true);
        }
        setBankAccountArray([]);
        const bankAccountNums = [];
        [...mandateRecords].forEach((row) => {
          row.nachBankVoList.forEach((bankRow) => {
            bankAccountNums.push(bankRow.bankAccountNum)
          });
        });
        setBankAccountArray(bankAccountNums);

        if (value) {
          setselectedAccountNum(value);
          const mandateRecordsData = [...mandateRecords].map((row) => {
            // every record will have different bankaccount number in real time.
            // set the bank values to the row.
            const bankrecord = row.nachBankVoList[0];
            createBankDetailsVo(row, bankrecord);
            return row;
          });
          const recordValue = mandateRecordsData.filter(
            (record) => record.bankAccountNum === value
          );
          dispatch(NachFilterReducerAction.updateValues(recordValue[0]));
          dispatch(NachFilterReducerAction.updateInitialLoad(recordValue[0]));
          dispatch(
            NachFilterReducerAction.updateMandateNum(recordValue[0].mandateNum)
          );
          dispatch(NachFilterReducerAction.updateBankAccountNumValue(value));
          dispatch(NachFilterReducerAction.updateShowMandate(false));
        } else {
          dispatch(NachFilterReducerAction.updateBankAccountNumValue(""));
          dispatch(
            NachFilterReducerAction.updateBankAccountNumTouchHandler(false)
          );
          dispatch(NachFilterReducerAction.updateShowMandate(false));
          dispatch(NachFilterReducerAction.resetValues());
        }
      }
    } else {
      dispatch(NachAction.setResetTouchHandler(false));
      if (editLockStatus) {
        setEditLockDialogOpen(true);
      }
      setBankAccountArray([]);
      const bankAccountNums = [];
      [...mandateRecords].forEach((row) => {
        row.nachBankVoList.forEach((bankRow) => {
          bankAccountNums.push(bankRow.bankAccountNum)
        });
      });
      setBankAccountArray(bankAccountNums);

      if (value) {
        setselectedAccountNum(value);
        const mandateRecordsData = [...mandateRecords].map((row) => {
          // every record will have different bankaccount number in real time.
          // set the bank values to the row.
          const bankrecord = row.nachBankVoList[0];
          createBankDetailsVo(row, bankrecord);
          return row;
        });
        const recordValue = mandateRecordsData.filter(
          (record) => record.bankAccountNum === value
        );
        dispatch(NachFilterReducerAction.updateValues(recordValue[0]));
        dispatch(NachFilterReducerAction.updateInitialLoad(recordValue[0]));
        dispatch(
          NachFilterReducerAction.updateMandateNum(recordValue[0].mandateNum)
        );
        dispatch(NachFilterReducerAction.updateBankAccountNumValue(value));
        dispatch(NachFilterReducerAction.updateShowMandate(false));
      } else {
        dispatch(NachFilterReducerAction.updateBankAccountNumValue(""));
        dispatch(
          NachFilterReducerAction.updateBankAccountNumTouchHandler(false)
        );
        dispatch(NachFilterReducerAction.updateShowMandate(false));
        dispatch(NachFilterReducerAction.resetValues());
      }
    }
  };

  //Search Button Handler
  const SearchButtonHandler = async () => {
    if (!detailScreenViewFlag) {
      dispatch(NachFilterReducerAction.updateBranchTouchHandler(true));
      dispatch(NachFilterReducerAction.updateApplicationTouchHandler(true));
      dispatch(NachFilterReducerAction.updateBankAccountNumTouchHandler(true));
      if (FilteredData.status === "NEW") {
        dispatch(NachFilterReducerAction.updateDisablesState(false));
      } else {
        dispatch(NachFilterReducerAction.updateDisablesState(true));
      }
      if (branchValid && applicationNumberValid && bankAccountNumValid) {
        if (FilteredData.status.toUpperCase() === "New".toUpperCase()) {
          // for new application we need to set emi amount as nach amount & mandate amount as twice of nach amount.
          const emiAmtValue = String(FilteredData.emiAmt);
          dispatch(
            NachFilterReducerAction.updateNachAmt(
              emiAmtValue ? emiAmtValue.replaceAll(",", "") : 0
            )
          );
          dispatch(
            NachFilterReducerAction.updateMandateAmt(
              emiAmtValue
                ? String(parseFloat(emiAmtValue.replaceAll(",", "")) * 2)
                : 0
            )
          );
        }
        loadFrequencyAndDebitType();
      } else {
        return;
      }
    }
  };

  const loadFrequencyAndDebitType = async () => {
    const nachLovValues = await axios.post("/lovMaster/getLovValues", {
      moduleId: "MD002",
    });

    const frequencyTypeData = nachLovValues.data["Frequency"].map((type) => {
      return {
        key: type.lovOrder,
        value: type.lovValues,
        text: type.lovValues,
      };
    });
    const debitTypeData = nachLovValues.data["Debit Type"].map((type) => {
      return {
        key: type.lovOrder,
        value: type.lovValues,
        text: type.lovValues,
      };
    });
    const mandateValidityData = nachLovValues.data["Mandate Validity"].map(
      (type) => {
        return {
          key: type.lovOrder,
          value: type.lovValues,
          text: type.lovValues,
        };
      }
    );
    dispatch(
      NachFilterReducerAction.updateFrequencyTypeArray(frequencyTypeData)
    );
    dispatch(NachFilterReducerAction.updateDebitTypeArray(debitTypeData));
    dispatch(
      NachFilterReducerAction.updateMandateValidityArray(mandateValidityData)
    );
    dispatch(NachFilterReducerAction.updateShowMandate(true));
  };

  //Clear Button Handler
  const ClearButtonHandler = () => {
    setMode("clearMode");
    if (detailScreenViewFlag) {
      const result = compareTwoArrayOfObjects([initialLoadData], [finalData]);
      if (!result) {
        setDialogOpen(true);
      } else {
        if (!editLock.editLockFlag) {
          let { editLockFlag, branch, applicationNumber } = editLock;
          if (branch !== "" && applicationNumber !== "") {
            releaseLock(branch, applicationNumber);
          }
        }
        dispatch(NachFilterReducerAction.updateShowMandate(false));
        dispatch(NachFilterReducerAction.updateBranchTouchHandler(false));
        dispatch(NachFilterReducerAction.updateApplicationTouchHandler(false));
        dispatch(NachFilterReducerAction.resetFilterValues());
        dispatch(NachFilterReducerAction.resetValues());
        dispatch(NachAction.updateFrequencyTouchHandler(false));
        dispatch(NachAction.updateDebitTypeTouchHandler(false));
        dispatch(NachAction.updateFbdTouchHandler(false));
        dispatch(NachAction.updateMandateStartDateTouchHandler(false));
        dispatch(NachAction.updateFirstNachBillingDateTouchHandler(false));
        dispatch(NachAction.updateMandateValidityTouchHandler(false));
        dispatch(NachAction.updateNachAmtTouchHandler(false));
        dispatch(NachAction.updateMandateAmtTouchHandler(false));
        dispatch(
          NachFilterReducerAction.updateBankAccountNumTouchHandler(false)
        );
        setApplicationArray([]);
        setBankAccountArray([]);
      }
    } else {
      dispatch(NachFilterReducerAction.updateShowMandate(false));
      dispatch(NachFilterReducerAction.updateBranchTouchHandler(false));
      dispatch(NachFilterReducerAction.updateApplicationTouchHandler(false));
      dispatch(NachFilterReducerAction.resetFilterValues());
      dispatch(NachFilterReducerAction.resetValues());
      dispatch(NachAction.updateFrequencyTouchHandler(false));
      dispatch(NachAction.updateDebitTypeTouchHandler(false));
      dispatch(NachAction.updateFbdTouchHandler(false));
      dispatch(NachAction.updateMandateStartDateTouchHandler(false));
      dispatch(NachAction.updateFirstNachBillingDateTouchHandler(false));
      dispatch(NachAction.updateMandateValidityTouchHandler(false));
      dispatch(NachAction.updateNachAmtTouchHandler(false));
      dispatch(NachAction.updateMandateAmtTouchHandler(false));
      dispatch(NachFilterReducerAction.updateBankAccountNumTouchHandler(false));
      setApplicationArray([]);
      setBankAccountArray([]);
    }
  };

  const onOkButtonClickHandler = () => {
    dispatch(NachFilterReducerAction.updateShowMandate(false));
    if (mode === "BranchMode") {
      if (!editLock.editLockFlag) {
        let { editLockFlag, branch, applicationNumber } = editLock;
        if (branch !== "" && applicationNumber !== "") {
          releaseLock(branch, applicationNumber);
        }
      }
      dispatch(
        NachFilterReducerAction.updateEditLockBranch(selectedData.label)
      );
      setApplicationArray([]);
      setBankAccountArray([]);

      // dispatch(NachFilterReducerAction.updateApplicationTouchHandler(false));
      dispatch(NachFilterReducerAction.resetValues());
      if (selectedData !== "") {
        dispatch(BranchAction.updateInitialLoad(false));
        dispatch(BranchAction.updateHeaderBranchDetails(selectedData.label));
      }

      dispatch(NachFilterReducerAction.updateApplicationValue(""));
      dispatch(NachFilterReducerAction.updateBankAccountNumValue(""));

      dispatch(NachFilterReducerAction.updateBranchValue(selectedData));
      const branchCodeValue = getSelectedBranchCode(selectedData.label);
      const applicationArray = losData.filter((item) => {
        return item.branchCode === branchCodeValue;
      });
      const app = applicationArray.map((itm) => itm.applicationNum);
      setApplicationArray(app);
    }
    if (mode === "applicationMode") {
      if (!editLock.editLockFlag) {
        let { editLockFlag, branch, applicationNumber } = editLock;
        if (branch !== "" && applicationNumber !== "") {
          releaseLock(branch, applicationNumber);
        }
      }
      dispatch(
        NachFilterReducerAction.updateEditLockApplicationNumber(selectedData)
      );
      dispatch(NachFilterReducerAction.updateApplicationValue(selectedData));
      dispatch(NachFilterReducerAction.updateBankAccountNumValue(""));
      dispatch(NachFilterReducerAction.updateShowMandate(false));
      dispatch(NachFilterReducerAction.resetValues());
      changeAppNumReq(selectedData);
    }
    if (mode === "accountMode") {
      dispatch(NachAction.setResetTouchHandler(false));
      if (editLockStatus) {
        setEditLockDialogOpen(true);
      }
      setBankAccountArray([]);
      const bankAccountNums = [];
      [...mandateRecords].forEach((row) => {
        row.nachBankVoList.forEach((bankRow) => {
          bankAccountNums.push(bankRow.bankAccountNum)
        });
      });
      setBankAccountArray(bankAccountNums);

      if (selectedData) {
        setselectedAccountNum(selectedData);
        const mandateRecordsData = [...mandateRecords].map((row) => {
          // every record will have different bankaccount number in real time.
          // set the bank values to the row.
          const bankrecord = row.nachBankVoList[0];
          createBankDetailsVo(row, bankrecord);
          return row;
        });
        const recordValue = mandateRecordsData.filter(
          (record) => record.bankAccountNum === selectedData
        );
        dispatch(NachFilterReducerAction.updateValues(recordValue[0]));
        dispatch(NachFilterReducerAction.updateInitialLoad(recordValue[0]));
        dispatch(
          NachFilterReducerAction.updateMandateNum(recordValue[0].mandateNum)
        );
        dispatch(
          NachFilterReducerAction.updateBankAccountNumValue(selectedData)
        );
        dispatch(NachFilterReducerAction.updateShowMandate(false));
      } else {
        dispatch(NachFilterReducerAction.updateBankAccountNumValue(""));
        dispatch(
          NachFilterReducerAction.updateBankAccountNumTouchHandler(false)
        );
        dispatch(NachFilterReducerAction.updateShowMandate(false));
        dispatch(NachFilterReducerAction.resetValues());
      }
    }
    if (mode === "clearMode") {
      if (!editLock.editLockFlag) {
        let { editLockFlag, branch, applicationNumber } = editLock;
        if (branch !== "" && applicationNumber !== "") {
          releaseLock(branch, applicationNumber);
        }
      }
      setApplicationArray([]);
      setBankAccountArray([]);
      dispatch(NachFilterReducerAction.updateShowMandate(false));
      dispatch(NachFilterReducerAction.updateBranchTouchHandler(false));
      dispatch(NachFilterReducerAction.updateApplicationTouchHandler(false));
      dispatch(NachFilterReducerAction.resetFilterValues());
      dispatch(NachFilterReducerAction.resetValues());
      dispatch(NachAction.updateFrequencyTouchHandler(false));
      dispatch(NachAction.updateDebitTypeTouchHandler(false));
      dispatch(NachAction.updateFbdTouchHandler(false));
      dispatch(NachAction.updateMandateStartDateTouchHandler(false));
      dispatch(NachAction.updateFirstNachBillingDateTouchHandler(false));
      dispatch(NachAction.updateMandateValidityTouchHandler(false));
      dispatch(NachAction.updateNachAmtTouchHandler(false));
      dispatch(NachAction.updateMandateAmtTouchHandler(false));
      dispatch(NachFilterReducerAction.updateBankAccountNumTouchHandler(false));
    }

    setDialogOpen(false);
  };
  const getNachSponserBankDetails = async () => {
    try {
      // const response = await axios.post(
      //   "https://bmapp.sundaramhome.in/stlms/ostlap/sblov",
      //   {}
      // );
      const response = await axios.post("/api/getSponserBankFromlos", {
        apiCode: "SPONSOR_BANK_LOV_API",
        createdBy: userNames,
        lastModifiedBy: userNames,
      });
      const sponserBank = response.data.sponsor_bank_dtls.map(
        (sponserBank) => sponserBank.bank_name
      );
      dispatch(NachFilterReducerAction.updateSponserBankArray(sponserBank));
    } catch {}
  };
  useEffect(() => {
    dispatch(NachFilterReducerAction.resetValues());
    dispatch(NachFilterReducerAction.resetFilterValues());
    dispatch(NachFilterReducerAction.updateApplicationTouchHandler(false));
    dispatch(NachFilterReducerAction.updateBranchTouchHandler(false));
    dispatch(NachFilterReducerAction.updateBankAccountNumTouchHandler(false));
    dispatch(NachFilterReducerAction.updateShowMandate(false));
    async function fetchLosData() {
      const response = await axios.get("/losCustomer/getAllData");
      const data = response.data.filter(
        (sanctionRow) => sanctionRow.losStatus === "Sanctioned" || "Requested"
      );
      setLosData(data);
      //setLosData(data);
    }
    fetchLosData();
    const branchValues = GetBranchDetails();
    setBranchArray(branchValues);
    getNachSponserBankDetails();
    return () => {
      //Method will call when the component unmount
      let branchValue = store.getState().nachFilter.filterData.branchValue;
      let applicationNumber =
        store.getState().nachFilter.filterData.applicationValue;
      let editLockFlag = store.getState().nachFilter.editLock.editLockFlag;
      if (!editLockFlag) {
        if (branchValue.label !== "" && applicationNumber !== "") {
          releaseLock(branchValue.label, applicationNumber);
        }
      }
    };
  }, []);
  useEffect(() => {
    //This useEffect for Page refresh

    window.addEventListener("beforeunload", alertUser);
    window.addEventListener("unload", call);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
      window.removeEventListener("unload", call);
    };
  }, [FilteredData]);
  const alertUser = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };
  const call = () => {
    let editLockFlag = store.getState().nachFilter.editLock.editLockFlag;
    let branchValue = store.getState().nachFilter.filterData.branchValue;
    let applicationNumber =
      store.getState().nachFilter.filterData.applicationValue;
    if (!editLockFlag) {
      if (branchValue.label !== "" && applicationNumber !== "") {
        releaseLock(branchValue.label, applicationNumber);
      }
    }
  };
  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const releaseLock = async (branch, applicationNumber) => {
    if (branch !== "" && applicationNumber !== "") {
      try {
        const branchCodeValue = getSelectedBranchCode(branch);
        const response = await axios.post("/nach/editLockUpdate", {
          applicationBranch: branch,
          applicationBranchCode: branchCodeValue,
          applicationNum: applicationNumber,
        });
      } catch {}
    }
  };
  return (
    <Box>
      <AccordianContainer
        id="accord"
        title="Create Mandate"
        initialOpen={true}
        sx={{ margin: "8px !important" }}
      >
        <Box sx={{ marginTop: "-1%" }}>
          <Grid container rowSpacing={0} columnSpacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Branch"
                label="Branch"
                required={true}
                autoCompleteValues={branchArray}
                value={filData.branchValue ? filData.branchValue : null}
                onBlur={() => {
                  dispatch(
                    NachFilterReducerAction.updateBranchTouchHandler(true)
                  );
                  // setBranchHasTouched(true);
                }}
                onChange={(event, newValue) => {
                  branchOnChangeHandler(newValue === null ? "" : newValue);
                }}
              />
              {branchHasError && <p className="error">Please Select Branch</p>}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Application Number"
                label="Application Number"
                autoCompleteValues={applicationArray}
                value={
                  filData.applicationValue ? filData.applicationValue : null
                }
                required={true}
                onBlur={() => {
                  // setApplicationHasTouched(true);
                  dispatch(
                    NachFilterReducerAction.updateApplicationTouchHandler(true)
                  );
                }}
                onChange={(event, value) => {
                  applicationNumberOnChangeHandler(value);
                }}
              />
              {applicationHasError && (
                <p className="error">Please Select Application Number</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                label="Bank Account Number"
                placeholder="Select Bank Account Number"
                autoCompleteValues={bankAccountArray}
                value={filData.bankAccountNum ? filData.bankAccountNum : null}
                required={true}
                onBlur={() => {
                  dispatch(
                    NachFilterReducerAction.updateBankAccountNumTouchHandler(
                      true
                    )
                  );
                }}
                onChange={(event, value) => {
                  changeBankAccountNumValue(value);
                  dispatch(
                    NachFilterReducerAction.updateBankAccountNumTouchHandler(
                      true
                    )
                  );
                }}
              />
              {bankAccountHasError && (
                <p className="error">Please Select Bank Account Number</p>
              )}
            </Grid>
            {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="Repay Application"
              variant="standard"
              placeholder="Enter Repay Application"
              value={FilteredData.repayApplication}
              disabled={true}
            />
          </Grid> */}
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Repay Mode"
                variant="standard"
                placeholder="Repay Mode"
                value={FilteredData.repay}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="EMI Amount (₹)"
                variant="standard"
                placeholder="Enter EMI amount"
                value={parseInt(FilteredData.emiAmt).toLocaleString("en-IN")}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="File Status"
                variant="standard"
                placeholder="File Status"
                value={FilteredData.status}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Sanctioned Loan Amount (₹)"
                variant="standard"
                value={parseInt(FilteredData.loanAmount).toLocaleString(
                  "en-IN"
                )}
                disabled={true}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="Disbursement Amount"
              variant="standard"
              placeholder="Enter Disbursement Amount"
              value={parseInt(FilteredData.disbursementAmount).toLocaleString(
                "en-IN"
              )}
              disabled={true}
            />
          </Grid> */}
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomDateField
                label="Sanctioned Date"
                variant="standard"
                value={FilteredData.sancationDate}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Box
            sx={{
              marginTop: "8px",
              marginBottom: "4px",
              display: "flex",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Ctrl+F" placement="top">
              <Button
                variant="contained"
                type="submit"
                sx={{ height: "2rem", fontWeight: "bold" }}
                onClick={SearchButtonHandler}
                ref={searchButtonRef}
              >
                Detail
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+D" placement="top">
              <Button
                sx={{
                  color: "white",
                  backgroundColor: "black",
                  height: "2rem",
                  fontWeight: "bold",
                }}
                onMouseOver={({ target }) => {
                  target.style.backgroundColor = "black";
                  target.style.color = "white";
                }}
                variant="contained"
                onClick={ClearButtonHandler}
                ref={clearRef}
              >
                Clear
              </Button>
            </Tooltip>
          </Box>
        </Box>
      </AccordianContainer>
      <Dialog
        open={editLockDialogOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Information</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            This Record is Being Edited by Other User, Click OK to Navigate View
            Screen.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+K" placement="top">
            <Button
              onClick={() => {
                editLockOkButonHandler();
              }}
              ref={editOkRef}
            >
              OK
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog open={DialogOpen}>
        <DialogTitle>
          <h4>Confirmation</h4>
        </DialogTitle>
        <DialogContent>Data Will be Reset to Default ?</DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button
              onClick={() => {
                setDialogOpen(false);
              }}
              ref={cancelRef}
            >
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+K" placement="top">
            <Button onClick={onOkButtonClickHandler} ref={okRef}>
              OK
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default NachFilter;
